var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 .5a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm3.131 11.131a.993.993 0 0 1-1.417 0l-1.508-1.52a.308.308 0 0 0-.412 0l-1.508 1.52a1.005 1.005 0 0 1-1.417 0 .972.972 0 0 1-.298-.708.995.995 0 0 1 .298-.709l1.52-1.508a.309.309 0 0 0 0-.412l-1.52-1.508a1.006 1.006 0 0 1 1.417-1.417l1.508 1.52a.309.309 0 0 0 .412 0l1.508-1.52a1.006 1.006 0 1 1 1.417 1.417l-1.52 1.508a.309.309 0 0 0 0 .412l1.52 1.508a.994.994 0 0 1 0 1.417Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCross);
export default __webpack_public_path__ + "static/media/delete-cross.69eda1e82c5088dc4fd47b9976e8c93e.svg";
export { ForwardRef as ReactComponent };